module.exports = __webpack_public_path__ + "static/img/07.e85a439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/07.jpg
// module id = UoII
// module chunks = 0